import comSpSkeleton from "../../../engines/components/comSpSkeleton";
import InteroperableObj from "../InteroperableObj";
import O1HD from "../../../engines/gameEngine";
import EggSurpise from "../EggSurpise";
import spendMode from "../spendMode";

const {menu,ccclass, property} = cc._decorator;

@ccclass
@menu("游戏中物体/坤坤")
export default class Chicken extends InteroperableObj {
    //TODO 点击小鸡下蛋  下了五个蛋的时候鸡会死掉 然后二姑会过来找麻烦  需要触发一个事件

    @property({type:comSpSkeleton,displayName:"鸡的动画"})
    ani:comSpSkeleton = null;

    @property({type:cc.Node,displayName:"篮球节点"})
    basketBall:cc.Node = null;
    @property(cc.Prefab)
    eggSurprisePrefab : cc.Prefab = null;
    @property(spendMode)
    mGameLayer : spendMode = null;

    clickCount:number = 0;

    randDeathCount:number = 0;

    canClick:boolean = true;

    onLoad(){
        super.onLoad();
        this.node.on("touchend",this.onTouchEnd,this);
        this.ani.playAnimation("Idle").start(true);
        this.startMoveAni();
        this.initObj();
    }

    onTouchEnd(e:cc.Event.EventTouch){
        if(!this.canClick) return;
        O1HD.getManagers().soundMgr.playSound("chicken").then();
        if(this.clickCount < 5){
            this.onChickenLayEggs();
        }else{
            this.canClick = false;
            this.chickenDeath();
        }
        this.clickCount ++;
    }

    initObj(){
        this.clickCount = 0;
        this.ani.node.opacity = 255;
        this.canClick = true;
        this.randDeathCount = Math.floor(Math.random()*5) +5;
    }

    startMoveAni(){
        this.node.scaleX = -1;
        this.ani.playAnimation("Move").start(true);
        cc.tween(this.node).by(2,{x:200}).call(()=>{
            this.ani.playAnimation(("Idle")).start(true);
        }).delay(0.2).call(()=>{
            this.ani.playAnimation("Dance").onComplete(1,()=>{
                this.ani.playAnimation("Idle").start(true);
                this.scheduleOnce(()=>{
                    this.node.scaleX = 1;
                    this.ani.playAnimation("Move").start(true);
                    cc.tween(this.node).by(2,{x:-200}).call(()=>{
                        this.ani.playAnimation("Idle").start(true);
                    }).delay(0.2).call(()=>{
                        this.ani.playAnimation("Dance").onComplete(2,()=>{
                            this.ani.playAnimation("Idle").start(true);
                            this.scheduleOnce(()=>{
                                this.startMoveAni();
                            },0.2);
                        }).start(false);
                    }).start();
                },.2);
            }).start(false);
        }).start();
    }

    stopMoveAni(){
        this.ani.playAnimation("Idle").start(true);
        cc.Tween.stopAllByTarget(this.node);
        cc.tween(this.ani.node).to(.2,{opacity:0}).start();
    }

    chickenDeath(){
        this.canClick = false;
        this.stopMoveAni();
        // 八大姨要求赔钱
        let eggSurpriseNode = cc.instantiate( this.eggSurprisePrefab );
        eggSurpriseNode.getComponent( EggSurpise ).bindEvent( "chicken" , this.mGameLayer );
        this.mGameLayer.uiNode.addChild( eggSurpriseNode );
    }

    onChickenLayEggs(){
        let basketBall:cc.Node = cc.instantiate(this.basketBall);
        basketBall.active = true;
        basketBall.setPosition(this.node.parent.convertToNodeSpaceAR(this.basketBall.convertToWorldSpaceAR(cc.v2())));
        basketBall.setParent(this.node.parent);
        let movex:number = this.node.scaleX < 1 ? -100 : 100;
        let angle:number = this.node.scaleX < 1 ? 360 : -360;
        cc.tween(basketBall).by(.2,{y:-50}).by(2,{x:movex,angle:angle}).to(.5,{opacity:0}).call(()=>{
            basketBall.destroy();
            basketBall.removeFromParent();
        }).start();
    }

}
